export default "__VITE_ASSET__D_QY7hzF__"